import { z, zCoercedBoolean } from '@harvestiq/zod';
import { RmaLrpTypeCodes } from '@harvestiq/constants';
import { zIsoDate } from '@harvestiq/zod';
import { lrpQuoteSchema } from '@harvestiq/usda-common';

export const lrpQuoteByTypeCodeAndSedRequestSchema = z.object({
  salesEffectiveDate: zIsoDate(),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
  targetWeightCwtPerHead: z.coerce.number().positive(),
  headCount: z.coerce.number().positive(),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
});

export type LrpQuoteByTypeCodeAndSedRequest = z.infer<
  typeof lrpQuoteByTypeCodeAndSedRequestSchema
>;

export const lrpQuoteByTypeCodeAndSedResponseSchema = z.object({
  data: lrpQuoteSchema.array(),
});

export type LrpQuoteByTypeCodeAndSedResponse = z.infer<
  typeof lrpQuoteByTypeCodeAndSedResponseSchema
>;
